import { __awaiter } from "tslib";
import EventEmitter from 'eventemitter3';
import { WebSocketError } from 'src/services/api/common/ws/WebSocketError';
export class UserController {
    constructor({ api, }) {
        this._profile = null;
        // region events
        this._events = new EventEmitter();
        this.api = api;
        this.api.auth.on('logout', () => {
            this.profileClear();
        });
        this.api.auth.on('login', () => {
            this.profileClear();
            this.profileUpdate().catch(err => console.error(err));
        });
        const profileStr = typeof localStorage !== 'undefined' && localStorage.getItem('userProfile');
        if (profileStr) {
            this._profile = JSON.parse(profileStr);
        }
    }
    on(name, listener) {
        this._events.on(name, listener);
        return () => {
            this._events.off(name, listener);
        };
    }
    // endregion
    profileClear() {
        if (this._profile) {
            this._profile = null;
            if (typeof localStorage !== 'undefined') {
                localStorage.removeItem('userProfile');
            }
            this._events.emit('profileChanged');
        }
    }
    profileUpdate() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.api.auth.isLoggedIn) {
                    return;
                }
                const result = yield this.api.request({
                    data: {
                        agent: 'user',
                        auth: { type: 'webSite' },
                        lang: 'en',
                        method: 'profile_getMyProfile',
                        params: {},
                    },
                });
                const profile = (_b = (_a = result === null || result === void 0 ? void 0 : result.result) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.value;
                if (!(profile === null || profile === void 0 ? void 0 : profile.userId)) {
                    throw new WebSocketError('userId is empty', 'invalid-response');
                }
                profile.nickname = profile.nickname.replace(/#([^#]+)$/, '');
                this._profile = profile;
                if (typeof localStorage !== 'undefined') {
                    localStorage.setItem('userProfile', JSON.stringify(this._profile));
                }
                this._events.emit('profileChanged');
            }
            catch (err) {
                console.error(err, Object.assign({}, err));
                throw err;
            }
        });
    }
    get profile() {
        return this._profile;
    }
}
